// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vgsG","title":"Header_title__dsyx4","left":"Header_left__3T5oA","clinicName":"Header_clinicName__22KHz"};